import React, { Component } from 'react';

export default class Carousel extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let options = this.props.options;
    options.items = options.items ? options.items : 1;
    options.navElement = options.navElement ? options.navElement : 'a';

    $(this.carousel).owlCarousel(options)
  }

  componentDidUpdate() {
    $(this.carousel).owlCarousel(this.props.options);
  }

  componentWillUpdate() {
    $(this.carousel).trigger('destroy.owl.carousel');
  }

  owlTheme() {
    if (this.props.disableOwlTheme) {
      return '';
    }

    return 'owl-theme';
  }

  render() {
    return (
      <div id={this.props.id}
        ref={c => {this.carousel = c}}
        className={`owl-carousel ${this.owlTheme()}`}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/OwlCarousel/Carousel.js